module.exports = __webpack_public_path__ + "media/images/ic_chat-started-d36976199218c2d689fefc45d642e0ce.svg";